import "../../../../../css/CashflowModeller2/Buttons/Dropdown.css";

/**
 * Dropdown component renders a container with a label.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.labelText - The text to display as the label.
 * @param {string} [props.className] - Optional additional class names for styling.
 * @returns {JSX.Element} The rendered Dropdown component.
 *  */
const Dropdown = ({ labelText, className }) => {
  return (
    <div className={`dropdown-button-container ${className || ""}`}>
      <div className="Label">{labelText}</div>
    </div>
  );
};

export default Dropdown;
